module.exports = __webpack_public_path__ + "img/3.518c5d14.jpg";